module.exports = __webpack_public_path__ + "img/arrowLeftHalfColonialWhite.952cafc4.svg";